import React, { useEffect, useState } from "react";
import { BarChart3, ArrowUp, ArrowDown } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";
import { api } from "@/lib/api";

const gbp = (v) => `£${Math.round(v || 0).toLocaleString("en-GB")}`;
const mon = (m) => new Date(`${m}-01T00:00:00`).toLocaleDateString("en-GB", { month: "short" });

export function SalesPerformanceCard() {
  const [months, setMonths] = useState(6);
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard/sales-performance", { params: { months } }).then((r) => setD(r.data)).catch(() => setD({ hidden: true })); }, [months]);
  if (d?.hidden) { return null; }
  const up = (d?.delta_pct ?? 0) >= 0;
  return (
    <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5" data-testid="sales-performance-card">
      <div className="flex items-center gap-2 pr-8">
        <BarChart3 className="w-4 h-4 text-indigo-500" />
        <h2 className="text-base font-bold text-slate-900 mr-auto">Sales performance</h2>
        <select value={months} onChange={(e) => setMonths(Number(e.target.value))} className="h-8 rounded-lg border border-slate-200 bg-white px-2 text-xs" data-testid="sales-performance-range">
          <option value={3}>Last 3 months</option><option value={6}>Last 6 months</option><option value={12}>Last 12 months</option>
        </select>
      </div>
      <div className="mt-3 flex items-baseline gap-3">
        <span className="text-3xl font-bold text-slate-900 tabular-nums" data-testid="sales-performance-total">{d ? gbp(d.total) : "…"}</span>
        {d?.delta_pct != null && <span className={`inline-flex items-center text-sm font-semibold ${up ? "text-emerald-600" : "text-rose-600"}`}>{up ? <ArrowUp className="w-3.5 h-3.5" /> : <ArrowDown className="w-3.5 h-3.5" />}{Math.abs(d.delta_pct)}%</span>}
      </div>
      <p className="text-xs text-slate-500">Paid web orders and shop sales{d?.delta_pct != null ? " · recent half vs earlier half" : ""}</p>
      <div className="h-48 mt-3">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={(d?.months || []).map((x) => ({ ...x, name: mon(x.month) }))} margin={{ left: -10, right: 4 }}>
            <CartesianGrid vertical={false} stroke="#f1f5f9" />
            <XAxis dataKey="name" tickLine={false} axisLine={false} fontSize={11} />
            <YAxis tickLine={false} axisLine={false} fontSize={11} tickFormatter={(v) => `£${Math.round(v / 1000)}k`} />
            <Tooltip formatter={(v, n) => [gbp(v), n === "web" ? "Web" : "Shop"]} />
            <Bar dataKey="web" stackId="s" fill="#3b5bfd" radius={[0, 0, 0, 0]} />
            <Bar dataKey="shop" stackId="s" fill="#a5b8ff" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="flex gap-4 text-xs text-slate-600 mt-1">
        <span className="flex items-center gap-1.5"><i className="w-2.5 h-2.5 rounded-full bg-[#3b5bfd]" />Web <b>{gbp(d?.web)}</b></span>
        <span className="flex items-center gap-1.5"><i className="w-2.5 h-2.5 rounded-full bg-[#a5b8ff]" />Shop <b>{gbp(d?.shop)}</b></span>
      </div>
    </div>
  );
}
